<template>
    <div v-route-title="'用户管理'">
        <div class="database-view">
            <div class="header-view pr">
                <span class="huishouzhan_title">用户管理</span>
                <div class="btn-layer">
                    <el-button @click="addRow" type="primary" icon="el-icon-circle-plus-outline">新建用户</el-button>
                </div>
            </div>
            <el-form class="search-form" inline :model="searchModel">
                <el-form-item>
                    <el-input v-model="searchModel.id" type="number" style="width: 90px;" placeholder="用户ID"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="searchModel.nameLike" style="width: 120px;" placeholder="用户名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="searchModel.userGroupIds" multiple clearable placeholder="用户组">
                        <el-option v-for="userGroup in userGroups" :key="userGroup.id"
                                   :label="userGroup.name" :value="userGroup.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
            <div v-if="data">
                <el-table class="yq-table" :data="data.content" style="width: 100%">
                    <el-table-column
                            type="index"
                            :index="indexMethod">
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            label="ID">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            label="用户名称">
                    </el-table-column>
                    <el-table-column
                            label="创建时间">
                        <pretty-date-time slot-scope="scope" :value="scope.row.createdAt"/>
                    </el-table-column>
                    <el-table-column
                            label="创建用户">
                        <span slot-scope="scope">{{scope.row.creator?scope.row.creator.name:''}}</span>
                    </el-table-column>
                    <el-table-column
                            label="修改时间">
                        <pretty-date-time slot-scope="scope" :value="scope.row.editedAt"/>
                    </el-table-column>
                    <el-table-column
                            label="修改用户">
                        <span slot-scope="scope">{{scope.row.editor?scope.row.editor.name:''}}</span>
                    </el-table-column>
                    <el-table-column
                            label="操作" width="210">
                        <template slot-scope="scope">
                            <el-link icon="el-icon-edit" @click="editRow(scope.row)">修改</el-link>
                            <el-link icon="el-icon-edit" @click="resetPwd(scope.row)">重置密码</el-link>
                            <el-link icon="el-icon-delete" @click="deleteRow(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="clear"></div>
        <div class="magin10"></div>
        <div class="foot" v-if="data">
            <el-pagination
                    layout="prev, pager, next" background
                    :total="data.totalElements" :current-page="data.number+1"
                    @current-change="fetchData($event)">
            </el-pagination>
        </div>
        <el-dialog v-if="model" :title="model.id?'修改用户':'添加用户'" :visible.sync="dialogFormVisible">
            <el-form ref="form" :model="model" label-width="120px" :rules="rules">
                <el-form-item label="用户名称" prop="name">
                    <el-input v-model="model.name"></el-input>
                </el-form-item>
                <el-form-item label="用户昵称" prop="nickName">
                    <el-input v-model="model.nickName"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="pwd" v-if="!model.id">
                    <el-input v-model="model.pwd" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="pwd2" v-if="!model.id">
                    <el-input v-model="model.pwd2" type="password"></el-input>
                </el-form-item>
                <el-form-item label="是否停用" prop="disabled">
                    <el-select v-model="model.disabled">
                        <el-option :value="false" label="否"></el-option>
                        <el-option :value="true" label="是"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="过期时间" prop="expiredAt">
                    <date-picker v-model="model.expiredAt"></date-picker>
                </el-form-item>
                <el-form-item label="用户组及角色" prop="groupAndRoles">
                    <div v-for="(gar,index) in model.groupAndRoles" :key="index">
                        <el-select v-model="gar.userGroup" placeholder="用户组" value-key="id">
                            <el-option v-for="userGroup in userGroups" :key="userGroup.id"
                                       :label="userGroup.name" :value="userGroup"></el-option>
                        </el-select>
                        <el-select v-model="gar.roles" multiple placeholder="角色" value-key="id">
                            <el-option v-for="role in roles" :key="role.id"
                                       :label="role.name" :value="role"></el-option>
                        </el-select>
                        <el-button @click="deleteGroupAndRole(index)">删除</el-button>
                    </div>
                    <el-button @click="addGroupAndRole">添加用户组</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog v-if="pwdModel" title="重置密码" :visible.sync="dialogPwdFormVisible">
            <el-form ref="pwdForm" :model="pwdModel" label-width="120px" :rules="pwdRules">
                <el-form-item label="密码" prop="pwd">
                    <el-input v-model="pwdModel.pwd" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="pwd2">
                    <el-input v-model="pwdModel.pwd2" type="password"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogPwdFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitPwdForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import userService from '../service/user'
    import roleService from '../service/role'
    import userGroupService from '../service/user-group'

    export default {
        name: "AdminUser",
        data() {
            const checkName = (rule, value, callback) => {
                if (value) {
                    userService.checkUserName(value).then(response => {
                        if (response.data && this.model.id !== response.data.id) {
                            callback(new Error('该用户已存在'));
                        } else {
                            callback();
                        }
                    }).catch(() => {
                        callback(new Error('校验出错'));
                    })
                } else {
                    callback();
                }
            }
            const checkPwd2 = (rule, value, callback) => {
                if (value && this.model.pwd && value !== this.model.pwd) {
                    callback(new Error('密码不一致'));
                } else {
                    callback();
                }
            }
            const checkGroupAndRoles = (rule, value, callback) => {
                if (value) {
                    const map = {}
                    for (const gar of value) {
                        if (gar.userGroup) {
                            if(map[gar.userGroup.id]) {
                                callback(new Error('请不要添加重复的用户组'));
                                return
                            } else {
                                map[gar.userGroup.id] = gar.userGroup
                            }
                        }
                    }
                    callback();
                } else {
                    callback();
                }
            }
            const checkPwd3 = (rule, value, callback) => {
                if (value && this.pwdModel.pwd && value !== this.pwdModel.pwd) {
                    callback(new Error('密码不一致'));
                } else {
                    callback();
                }
            }
            return {
                searchModel: {
                    id: null,
                    nameLike: null,
                    pageType: null
                },
                searchParams: {
                    id: null,
                    nameLike: null,
                    pageType: null
                },
                userGroups: [],
                data: null,
                dialogFormVisible: false,
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入用户名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'},
                        {validator: checkName, trigger: 'blur'}
                    ],
                    nickName: [
                        {required: true, message: '请输入用户昵称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                    pwd: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                    pwd2: [
                        {required: true, message: '请输入确认密码', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'},
                        {validator: checkPwd2, trigger: 'blur'}
                    ],
                    disabled: [
                        {required: true, message: '请选择是否停用', trigger: 'blur'},
                    ],
                    groupAndRoles: [
                        {validator: checkGroupAndRoles, trigger: 'blur'}
                    ]
                },
                pwdModel: null,
                dialogPwdFormVisible: false,
                pwdRules: {
                    pwd: [
                        {required: true, message: '请输入密码', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ],
                    pwd2: [
                        {required: true, message: '请输入确认密码', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'},
                        {validator: checkPwd3, trigger: 'blur'}
                    ]
                }
            }
        },
        created() {
            this.fetchCommonData()
            this.fetchData(1)
        },
        methods: {
            async fetchCommonData() {
                this.userGroups = (await userGroupService.listUserGroups()).data
                this.roles = (await roleService.listRoles({page: 0, size: 1000})).data.content
            },
            async fetchData(page) {
                const params = Object.assign({},this.searchParams,{page: page - 1, size: 10})
                const response = await userService.listUsers(params)
                await userService.fetchCreatorAndEditor(response.data.content)
                this.data = response.data
            },
            indexMethod(index) {
                return this.data.number * this.data.size + index + 1
            },
            search(){
                this.searchParams = JSON.parse(JSON.stringify(this.searchModel))
                this.fetchData(1)
            },
            addRow() {
                this.model = {
                    name: null,
                    nickName: null,
                    pwd: null,
                    pwd2: null,
                    disabled: false,
                    expiredAt: null,
                    groupAndRoles: null
                }
                if(this.$refs.form){
                    this.$refs.form.clearValidate()
                }
                this.dialogFormVisible = true
            },
            editRow(row) {
                if (row.fixed) {
                    this.$message({
                        type: 'error',
                        message: '无法修改内置用户!'
                    })
                    return
                }
                userService.getUser(row.id).then(response => {
                    this.model = response.data
                    if(this.$refs.form){
                        this.$refs.form.clearValidate()
                    }
                    this.dialogFormVisible = true
                })
            },
            addGroupAndRole() {
                if (this.model.groupAndRoles) {
                    this.model.groupAndRoles.push({
                        userGroup: null,
                        roles: []
                    })
                } else {
                    this.$set(this.model, 'groupAndRoles', [{
                        userGroup: null,
                        roles: []
                    }])
                }
            },
            deleteGroupAndRole(index) {
                this.model.groupAndRoles.splice(index, 1)
            },
            submitForm() {
                this.$refs.form.validate().then(() => {
                    if (this.model.id) {
                        userService.updateUser({
                            id: this.model.id,
                            data: this.model
                        }).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number + 1)
                            this.$message({
                                type: 'success',
                                message: '修改成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '修改失败!'
                            })
                        })
                    } else {
                        const formData = JSON.parse(JSON.stringify(this.model))
                        delete formData.pwd2
                        userService.addUser(formData).then(() => {
                            this.dialogFormVisible = false
                            this.fetchData(this.data.number + 1)
                            this.$message({
                                type: 'success',
                                message: '添加成功!'
                            })
                        }).catch(() => {
                            this.$message({
                                type: 'error',
                                message: '添加失败!'
                            })
                        })
                    }
                }).catch(() => {
                })
            },
            resetPwd(row) {
                this.pwdModel = {
                    id: row.id,
                    pwd: null,
                    pwd2: null
                }
                if(this.$refs.pwdForm){
                    this.$refs.pwdForm.clearValidate()
                }
                this.dialogPwdFormVisible = true
            },
            submitPwdForm(){
                this.$refs.pwdForm.validate().then(() => {
                    userService.resetPwd({
                        id: this.pwdModel.id,
                        data: {
                            pwd: this.pwdModel.pwd
                        }
                    }).then(() => {
                        this.dialogPwdFormVisible = false
                        this.$message({
                            type: 'success',
                            message: '重置密码成功!'
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'error',
                            message: '重置密码失败!'
                        })
                    })
                }).catch(() => {
                })
            },
            deleteRow(row) {
                if (row.fixed) {
                    this.$message({
                        type: 'error',
                        message: '无法删除内置用户!'
                    })
                    return
                }
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    userService.deleteUser(row.id).then(() => {
                        if (this.data.content.length > 1) {
                            this.data.content.splice(this.data.content.indexOf(row), 1)
                        } else {
                            this.fetchData(this.data.number > 0 ? this.data.number : 1)
                        }
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'error',
                            message: '删除失败!'
                        })
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        }
    }
</script>
